let mediaQueryDetectorElem;

export function initialize() {
    // Media query detector stuff.
    mediaQueryDetectorElem = document.getElementById('app-media-query-detector');

    return Promise.resolve();
}

export function isDesktop() {
    return Boolean(mediaQueryDetectorElem.offsetParent);
}
export function getRandomString(length) {
    var result = [];
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
    }
    return result.join('');
}

export function isMobile() {
    return !mediaQueryDetectorElem.offsetParent;
}

export const getSubDomain = (location) => {
    const locationParts = location.split('.');

    let sliceTill = -2;

    // for localhost
    const isLocalHost = locationParts.slice(-1)[0] === 'localhost';
    if (isLocalHost) sliceTill = -1;

    return locationParts.slice(0, sliceTill).join('');
};

export const getOriginDomain = (location) => {
    const locationParts = location.split('.');

    return locationParts[locationParts.length - 1].replace(/^https?:\/\//, '');
};

export const getDomain = (location) => {
    const locationParts = location.split('.');
    return locationParts.slice(1).join('.');
};
